import { useState, useCallback, useEffect } from 'react';

export default versions => {
  const currentVersion = versions.find(v => v.status === 'published') || {};
  const [version, selectVersion] = useState({ currentVersion });

  useEffect(() => {
    selectVersion(currentVersion);
  }, [versions.length]);

  const handleVersionSelect = useCallback(
    v => selectVersion(versions.find(ver => v.id === ver.id)),
    [versions.length],
  );

  return [{ version }, { handleVersionSelect }];
};
